import React, { useEffect, useState } from "react";
import "./style.css";
import { NewsViewItem } from "../../components/news/NewsViewItem";
import { Timeline } from "antd";
import { getNews } from "../../services/index";
import { ClockCircleOutlined } from '@ant-design/icons';
const NewsView = () => {
  const [newList, setNewList] = useState([]);
  useEffect(() => {
    getNewsList({
      page: 1,
      pageSize: 10,
    });
  }, []);
  const getNewsList = (params) => {
    getNews(params).then((res) => {
      if (res.code == 200) {
        setNewList(res.data.data);
      }
    });
  };
  return (
    <div id="news" className="news_div">
      <div className="news_view_title">
        <div className="news_vt_div">
          <img src="./img/newsbt.png" />
        </div>
      </div>
      <div className="news_list_view">
        <Timeline>
          {newList.length > 0 &&
            newList.map((s, i) => {
              return(
                <Timeline.Item
                dot={
                  <ClockCircleOutlined
                    style={{
                      fontSize: '20px',
                    }}
                  />
                }>
                  <NewsViewItem key={i} data={s} />
                </Timeline.Item>
              )
            })}
          
        </Timeline>
      </div>
    </div>
  );
};
export default NewsView;
